module.exports = __webpack_public_path__ + "static/img/eco_logo.4fdf5c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eco_logo.png
// module id = Gl0O
// module chunks = 1